import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";
import { connect } from "react-redux";

import { NOTE_TYPE_SSE } from "constants/dbValues";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  selectProps,
  displayErrorContext,
  renderProjectSelectOption,
} from "utils";
import logoColors from "assets/images/logo_colors.png";
import { Header } from "components";
import { Icon, Input, notification, Button, Checkbox, Select, Spin } from "antd";

import { noteService, projectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class SseVisitorPage extends Component {
  constructor(props) {
    super(props);
    const { id } = this.props.match.params;

    this.state = {
      note: {
        created_by: 99,
        status: 1,
        type_id: NOTE_TYPE_SSE,
      },
      sent: false,
      uploading: false,
      errors: {},
      edited: false,
      projects: [],
      path: "sse",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    this.doclist = React.createRef();
    this.fetchSelects();
  }

  async fetchSelects() {
    const projects = await projectService.list({
      order_by: "code,label",
      order_direction: "ASC,ASC",
      disabled: 0,
    });
    this.setState({ projects });
  }

  formatTag(key, fixed = false, label = "") {
    const { note, errors } = this.state;
    const { create } = this.props;
    const noteData = { ...note }; // avoids undesirable state modification

    var input;
    if (key === "status") {
      input = (
        <Checkbox
          name={key}
          checked={isChecked(noteData[key])}
          onChange={(e) => this.handleChange(e.target.checked, key)}
        >
          {label}
        </Checkbox>
      );
    } else if (key === "project_id") {
      const list = this.state.projects,
        computeLabel = renderProjectSelectOption;

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          value={noteData[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else {
      var Tag = key === "text" ? Input.TextArea : Input;
      let inputProps = key === "text" ? { autoSize: { minRows: 3, maxRows: 20 } } : null;

      input = (
        <Tag
          name={key}
          value={noteData[key]}
          {...inputProps}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({ note: { ...this.state.note, [key]: value }, edited: true });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var note = { ...this.state.note };
    const { path } = this.state;
    const { edit, create } = this.props;

    var func;
    func = noteService.create;
    note.date = new Date();

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(note)
        .then((n) => {
          notification.open({
            message: "Enregistrement effectué",
            description: "Vos changements ont été enregistrés avec succès.",
            placement: "bottomRight",
          });

          this.setState({ note: { ...note, ...n }, edited: false, uploading: false, sent: true });
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { note } = this.state;
    const { edit, create } = this.props;

    var fields = ["project_id", "text"];
    var validation = validateProfileFields(note, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { note, errors, path, uploading, sent } = this.state;
    const { edit, create, type } = this.props;

    const term = "intervention",
      directPrefix = "l'",
      contentLabel = "Description de l’intervention SSE :";

    var mode = "create",
      pageTitle = `Création d'une ${term}`,
      header = `Nouvelle ${term}`;

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        {sent ? (
          <>
            <center>
              <img src={logoColors} alt="CLB Logo" />
              <Header title={header + " envoyée !"} />
            </center>
            <div className={`note-page main-content profile-content ${mode}`}>
              Votre intervention a bien été envoyée. Merci de votre contribution.
              <br />
              <br />
              <Button type="link" onClick={() => history.replace(`/`)}>
                Se connecter à l'application
              </Button>
            </div>
          </>
        ) : (
          <>
            <center>
              <img src={logoColors} alt="CLB Logo" />
              <Header title={header} />
            </center>
            <div className={`note-page main-content profile-content ${mode}`}>
              <Spin
                indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
                spinning={uploading}
              >
                {mode === "read" && (
                  <>
                    <ul className="tags">
                      <li>{this.formatTag("project_id")}</li>
                      <li className="alt">{this.formatTag("status", false, "Ouverte")}</li>
                    </ul>
                  </>
                )}

                <ul className={"profile-main-content " + mode}>
                  <li>
                    <label>Projet :</label>
                    {this.formatTag("project_id", true)}
                  </li>
                  <li>
                    <label style={{ marginRight: 6 }}>Créée par :</label>
                    {this.formatTag("visitor_name", true)}
                  </li>

                  <li className="note-content">
                    <label>{contentLabel}</label>
                    {this.formatTag("text")}
                  </li>
                </ul>
                {create && (
                  <Fragment>
                    {displayErrorContext(errors)}

                    <div className="buttons">
                      <Button
                        type="primary"
                        onClick={() => this.handleSubmit()}
                      >{`Créer ${directPrefix}${term}`}</Button>
                    </div>

                    <Prompt
                      when={this.state.edited}
                      message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                    />
                  </Fragment>
                )}
              </Spin>
            </div>
          </>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(SseVisitorPage);
